const GB = {
  company: [
    "private limited company (Ltd)",
    "limited liability company (LLC)",
    "charitable incorporated organization (CIO)"
  ],
  legalArrangement: [
    "limited liability partnership (LLP)",
    "Scottish limited partnership (SLP)",
    "co-operative"
  ]
};
export {
  GB as default
};
